import { ifCampaign } from '../utils/authorization.js';

export default [
    {
        path: '/campaigns',
        name: 'campaigns',
        component: () => import(/* webpackChunkName: "campaigns" */ '../views/Campaigns/CampaignList.vue'),
        beforeEnter: ifCampaign,
        meta: {
            title: 'campaigns.listing.pageTitle',
        },
    },
    {
        path: '/campaigns/:id',
        name: 'campaign',
        component: () => import(/* webpackChunkName: "campaigns" */ '../views/Campaigns/CampaignContactList.vue'),
        beforeEnter: ifCampaign,
        meta: {
            title: 'campaigns.contactListing.pageTitle',
        },
    },
    {
        path: '/campaigns/:campaignId/import',
        name: 'campaigns.import.upload',
        component: () => import(/* webpackChunkName: "campaigns-import" */ '../views/Campaigns/ImportUpload.vue'),
        beforeEnter: ifCampaign,
        meta: {
            title: 'imports.pageTitle.campaigns',
            mayChangeAccount: false,
        },
    },
    {
        path: '/campaigns/:campaignId/import/:id/match',
        name: 'campaigns.import.match',
        component: () => import(/* webpackChunkName: "campaigns-import" */ '../views/Campaigns/ImportMatch.vue'),
        beforeEnter: ifCampaign,
        meta: {
            title: 'imports.pageTitle.campaigns',
            mayChangeAccount: false,
        },
    },
    {
        path: '/campaigns/:campaignId/import/:id/preview',
        name: 'campaigns.import.preview',
        component: () => import(/* webpackChunkName: "campaigns-import" */ '../views/Campaigns/ImportPreview.vue'),
        beforeEnter: ifCampaign,
        meta: {
            title: 'imports.pageTitle.campaigns',
            mayChangeAccount: false,
        },
    },
];
